module.exports = __webpack_public_path__ + "img/progress-minus.64c47788.png";